import React from 'react'
import { motion } from 'framer-motion'
import { TrendingUp, Award, Users, CheckCircle } from 'lucide-react'
import SEO from '../components/SEO'

const TrainingDevelopment = () => {
  const programs = [
    'Customized training programs',
    'Industry certifications',
    'Soft skills development',
    'Leadership training'
  ]

  return (
    <div>
      <SEO
        title="Corporate Training & Development Programs in Hyderabad | SV Manpower"
        description="Enhance your workforce capabilities with corporate training and development programs in Hyderabad. We offer customized skills training, soft skills, and leadership programs."
        keywords="corporate training Hyderabad, workforce development programs, skills enhancement training, soft skills training Hyderabad, leadership development Kukatpally"
        url="https://svmanpower.com/services/training-development"
      />
      <section className="relative text-white py-20 lg:pt-32 bg-cover bg-center bg-no-repeat hero-bg-position" style={{ backgroundImage: 'url(/hero.webp)' }}>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-600/80 to-primary-800/80"></div>
        <div className="container-max relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Training & Development</h1>
            <p className="text-xl md:text-2xl text-primary-100">Professional development programs to enhance your team's capabilities</p>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-secondary-900 mb-6">Skills Enhancement Programs</h2>
              <p className="text-secondary-600 mb-6">Invest in your workforce with our comprehensive training and development programs. We help your team acquire new skills and advance their careers.</p>
              <ul className="space-y-3">
                {programs.map((program, index) => (
                  <li key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                    <span className="text-secondary-700">{program}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Training & Development" className="rounded-lg shadow-xl" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default TrainingDevelopment
